import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-blue-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-6">Meine Verbindung zu Lauingen</h2>
          <div className="w-24 h-1 bg-yellow-400 mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <ul className="space-y-6 text-lg">
              <li className="flex items-start">
                <div className="bg-yellow-400 w-3 h-3 rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <span>Seit 2009 meine private und politische Heimat</span>
              </li>
              <li className="flex items-start">
                <div className="bg-yellow-400 w-3 h-3 rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <span>2. Vorsitzender AWO Lauingen</span>
              </li>
              <li className="flex items-start">
                <div className="bg-yellow-400 w-3 h-3 rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <span>Aktiver Helfer der Tafel Dillingen - Ausgabestelle Lauingen</span>
              </li>
              <li className="flex items-start">
                <div className="bg-yellow-400 w-3 h-3 rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <span>Mitglied: VdK Lauingen, Ortsverkehrswacht Lauingen, Kulturmarkt Lauingen e.V.</span>
              </li>
            </ul>
          </div>
          
          <div className="bg-white bg-opacity-10 p-8 rounded-lg">
            <h3 className="text-2xl font-bold mb-4 text-yellow-400">Netzwerk-Administrator</h3>
            <p className="text-lg leading-relaxed">
              Gründer und Administrator eines reichweitenstarken Netzwerks regionaler 
              Facebook-Communities im Landkreis Dillingen mit jeweils vierstelligen 
              Mitgliederzahlen, die als zentrale Informationsknotenpunkte der Region dienen.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;